import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {PaymentMethod} from 'src/app/models/PaymentMethod';
import {Venue} from 'src/app/models/Venue';

export const isWolt = (order: Order): boolean => {
	return order.method === PaymentMethod.WOLT;
};

export const isUber = (order: Order) => {
	return order.method === PaymentMethod.UBER_EATS;
};

export const checkIfOrderPool = (
	value: Order | OrderPool
): value is OrderPool => {
	return (
		(value as OrderPool)?.dndCompany != undefined &&
		(value as OrderPool)?.orders != undefined
	);
};

export const checkIfManualAcceptedView = (
	order: Order | OrderPool,
	venue: Venue | null
) => {
	if (!venue) {
		return false;
	}
	if (checkIfOrderPool(order)) {
		return false;
	}
	if (isWolt(order)) {
		if (
			!venue?.externalOrderProviders?.wolt?.autoAccept &&
			!venue?.externalOrderProviders?.wolt?.autoAcceptByPos &&
			!order.externalOrderAcceptedBy
		) {
			return true;
		}
	}

	if (isUber(order)) {
		if (
			!venue?.externalOrderProviders?.uberEats?.autoAccept &&
			!venue?.externalOrderProviders?.uberEats?.autoAcceptByPos &&
			!order.externalOrderAcceptedBy
		) {
			return true;
		}
	}

	return false;
};
